import styled from 'styled-components';

export const ActionBoletoButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  button {
    height: 32px;
  }
`;
